module.exports = __webpack_public_path__ + "img/placeholder_empty.e4f01842.jpg";